<template>
  <v-text-field
    variant="outlined"
    density="comfortable"
    color="primary"
  >
    <template v-if="$slots['append-inner']" #append-inner>
      <slot name="append-inner" />
    </template>
  </v-text-field>
</template>